import { useTranslation } from 'react-i18next';
import { PHONE_COUNTRY_PREFIXES, nationalLengthFor, normalizeNationalNumber } from '../../app/data/phoneCountryPrefixes';

const RegisterMobilePrefixInput = ({
  handleChange,
  values,
  errors,
  field,
  max_length,
  moduleText,
  occupation = 6,
  isRequired = true,
  prefix,
  onPrefixChange,
  setValues,
}) => {
  const { t } = useTranslation();
  const { max } = nationalLengthFor(prefix);

  return (
    <div className={`col-md-${occupation}`}>
      <label htmlFor={field} className="form-label">
        {t(`${moduleText}.short.${field}`)}
      </label>
      <div className="control d-flex gap-2">
        <select
          className="form-select form-select-lg"
          style={{ width: '6.6rem', flex: '0 0 6.6rem' }}
          aria-label={t('register.screen.mobile_prefix')}
          value={prefix?.iso || 'EC'}
          onChange={(event) => {
            const next = PHONE_COUNTRY_PREFIXES.find((item) => item.iso === event.target.value);
            if (next && onPrefixChange) {
              onPrefixChange(next);
              const trimmed = normalizeNationalNumber(values[field], next);
              if (trimmed !== (values[field] || '') && setValues) {
                setValues((current) => ({ ...current, [field]: trimmed }));
              }
            }
          }}
        >
          {PHONE_COUNTRY_PREFIXES.map((item) => (
            <option key={`${item.iso}-${item.name}`} value={item.iso}>
              {`${item.flag} ${item.dial}`}
            </option>
          ))}
        </select>
        <input
          autoComplete="off"
          className={`form-control form-control-lg ${errors[field] && 'is-invalid'}`}
          type="text"
          name={field}
          id={field}
          inputMode="numeric"
          onChange={(event) => {
            event.target.value = normalizeNationalNumber(event.target.value, prefix);
            handleChange(event, field);
          }}
          value={values[field] || ''}
          required={isRequired}
          maxLength={max}
          placeholder={t(`${moduleText}.short.${field}`)}
        />
      </div>
      {errors[field] && <pre> <p className="help text-danger">{errors[field]}</p> </pre>}
    </div>
  );
};

export default RegisterMobilePrefixInput;
